export const CHANGE_CATEGORY = 'CHANGE_CATEGORY';
export const changeCategory = category => ({
  type: CHANGE_CATEGORY,
  payload: category,
});
